export default __webpack_public_path__ + "static/media/handshake.1d842254.svg";